module.exports = __webpack_public_path__ + "6ab773f0459ee55149d1da2238189d41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Gifbit.jpg
// module id = 41
// module chunks = 0